<payment-card *ngIf="showPaymentCardComponent"></payment-card>
<payment-bluecode *ngIf="showPaymentBluecodeComponent"></payment-bluecode>
<payment-gift-card *ngIf="showGiftCardPaymentComponent"></payment-gift-card>
